<template>
    <div class="form-page">
        <my-form 
            readonly
            v-model="form" 
            table>
            <el-form-item 
                label="标段名称"  
                class="table-full-row">
                    {{form.bdname}}
            </el-form-item>
            <el-form-item 
                label="中标人" 
                class="table-full-row">
                   {{form.tbdwcode}}
            </el-form-item>

            <el-form-item 
                label="附件"  
                class="table-full-row">
                    <my-upload 
                        readonly
                        :file-guid="form.fileguid" 
                        file-type=".pdf"  
                        :file-size="100"
                        @signature="signature">
                    </my-upload>
            </el-form-item>

            <template slot="btn" slot-scope="scope">

                <el-button @click="scope.submitHandler" type="primary" icon="el-icon-circle-check">
                    提交
                </el-button>

                <el-button 
                icon="el-icon-circle-close" 
                @click="scope.cancleHandler">
                    取消
                </el-button>
            </template>
        </my-form>
        <el-dialog
            title="在线签章"
            :visible.sync="CAqzDialogVisible"
            width="1000px">
            <div style="width:900px;height:580px;margin:0 auto">
                <iframe 
                    id="iframeId" 
                    :src="iframeUrl" 
                    frameborder="0" 
                    style="width:900px;height:580px;margin:0 auto">
                </iframe>
            </div>
            <div slot="footer" class="dialog-footer" style="text-align:center">
                <el-button type="primary" @click="sign">签章</el-button>
                <el-button type="warning" @click="saveQz">保存签章</el-button>
                <el-button @click="CAqzDialogVisible = false">取 消</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import FORM_PAGE_MIXIN from "@views/mixins/form-page";
import MyUpload from '../components/my-upload' //上传附件
export default {
    mixins: [FORM_PAGE_MIXIN],
    components:{ MyUpload },
    data() {
        return{
            form:{
                fileguid:''
            },
          
        }
    },
    computed: {

    },
    watch: {
        
    },
    methods: {
        
    },
    created() {
       
    },
    mounted() {
        var that = this;
        //获取详情
        that.$get(`${this.getGetters('bidUrl')}/DingBiao/ZbJgTzs/xingtai/seal/detail.json`,{
            guid:that.getQuery('guid')
        },(data, res) => {
            that.form = data;
        })
        

    }
}
</script>

<style scoped lang="scss">

</style>
